export default "__VITE_ASSET__DnLvajB6__"